import AppShell from '@common/AppShell/AppShell';
import { SelfServiceContainer } from './containers/SelfService';

const SelfService = () => {
  return (
    <AppShell translationRoot="self-service">
      <SelfServiceContainer />
    </AppShell>
  );
};

export default SelfService;
